import { defaultBody } from '@/shared/functions/maps';
import api from '../axios-api';

const MODEL = 'Notification';
const baseUrl = `${MODEL}/`;

const list = async (params) => {
  if (!params) {
    params = {};
  }
  params.pageSize = 100;

  try {
    const response = await api.get(baseUrl, { params });
    return response.data;
  } catch (error) {
    throw error.message;
  }
};

const get = async (id) => {
  try {
    const response = await api.get(`${baseUrl}${id}/`);
    return response.data;
  } catch (error) {
    throw error.message;
  }
};

const create = async (body) => {
  const newBody = defaultBody({ MODEL, body });
  try {
    const response = await api.post(baseUrl, newBody);
    return response.data;
  } catch (error) {
    throw error.message;
  }
};

const update = async (id, body) => {
  const newBody = defaultBody({ MODEL, body, id });
  try {
    const response = await api.patch(`${baseUrl}${id}/`, newBody);
    return response.data;
  } catch (error) {
    throw error.message;
  }
};

const remove = async (id) => {
  try {
    const response = await api.delete(`${baseUrl}${id}/`);
    return response.data;
  } catch (error) {
    throw error.message;
  }
};

// const startNotificationListener = (params = {}) => {
//   const pollNotifications = async () => {
//     try {
//       const response = await list({
//         read: false,
//         ...params,
//       });
//       if (response.data && response.data.length > 0) {
//         window.dispatchEvent(
//           new CustomEvent('new-notifications', {
//             detail: response.data,
//           })
//         );
//       }
//     } catch (error) {
//       console.error('Erro ao buscar notificações:', error);
//     }
//   };

  //   // Faz a primeira busca imediatamente
  //   pollNotifications();

  //   // Inicia o polling a cada 30 segundos
  //   const intervalId = setInterval(pollNotifications, 30000);

  //   return () => clearInterval(intervalId);
  // };

export default {
  list,
  create,
  get,
  update,
  remove,
  // startNotificationListener,
};
